import React from "react";
import { Link } from "gatsby-plugin-react-i18next";
import starIcon from "../../assets/images/star-icon.png";
import PeerInvite from "../../assets/images/case-study/PeerInvite.png";
import shape1 from "../../assets/images/shape/map-shape1.png";
import shape4 from "../../assets/images/shape/vector-shape4.png";
import shape5 from "../../assets/images/shape/vector-shape5.png";
import { useTranslation } from "gatsby-plugin-react-i18next";

const PBc = () => {
	const { t } = useTranslation();

	return (
		<div className="scientist-area pb-70">
			<div className="container">
				<div className="row align-items-center">
					<div className="col-lg-7 col-md-12">
						<div className="scientist-box-list">
							<div className="map-shape1">
								<img src={shape1} alt="banner" />
							</div>
							<div className="vector-shape5">
								<img src={shape5} alt="banner" />
							</div>
						</div>
					</div>

					<div className="col-lg-5 col-md-12">
						<div className="scientist-section-title">
							<span className="sub-title">
								<img src={starIcon} alt="banner" />
								{t("home.PBci")}
							</span>
							<h2>{t("home.PBch2")}</h2>
							<p>{t("home.PBcp")}</p>

							<div className="col-lg-6 col-sm-12 col-md-6 offset-lg-0 offset-md-3">
								<div className="single-scientist-item">
									<img src={PeerInvite} alt="banner" />
								</div>
							</div>

							<Link
								to="/employee-reference-solutions"
								className="default-btn"
							>
								<i className="flaticon-view"></i>
								{t("EnSavoirPlus")}
								<span></span>
							</Link>
						</div>
					</div>
				</div>
			</div>

			<div className="vector-shape4">
				<img src={shape4} alt="banner" />
			</div>
		</div>
	);
};

export default PBc;
